
























































import { FinanceType, LoadingStatusType, TransactionType, TypeComponentNoti } from "@/enums/enums";
import { MerchantId } from "@/helper/authenticationHelper";
import { GetURLName } from "@/helper/documentHelper";
import { IsKeyBoardEN, ValidateEmailFormatError } from "@/helper/shareHelper";
import { DataPaySolutionPaymentModel, PaySolutionRequestModel } from "@/model/payment/paymentModel";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StorePayment = namespace("Payment");
const StoreLoading = namespace("Loading");
const StoreAlert = namespace("Alert");

@Component
export default class ModalInfoToConfirmPaymentPaySolutions extends Vue {
  @Prop({ default: 0 }) transactionId!: number;
  @Prop({ default: TransactionType.None }) transactionType!: TransactionType;
  @Prop({ default: FinanceType.None }) financeType!: FinanceType;
  @Prop({ default: "" }) transactionNumber!: string;
  @Prop({ default: 30 }) timeWaitingPayment!: number;

  private showModal = true;
  private isShowFormSubmit = false;
  private postBackUrl = `${process.env.VUE_APP_PeakDocument}${GetURLName(
    this.transactionType,
    this.financeType
  )}?emi=${MerchantId().PeakEncryption()}&eti=${this.transactionId.PeakEncryption()}&etti=${this.transactionType.PeakEncryption()}&efti=${this.financeType.PeakEncryption()}`;
  private email = {
    value: "",
    validateError: false,
  };

  @StorePayment.Getter
  private getPaySolutionPaymentLoadingStatus!: LoadingStatusType;
  @StorePayment.Getter
  private getPaySolutionPaymentModel!: DataPaySolutionPaymentModel;

  @StorePayment.Action
  private DoGetPaySolutionPayment!: (input: PaySolutionRequestModel) => void;
  @StoreLoading.Action
  private IsLoading!: (input: boolean) => void;
  @StoreAlert.Action
  private SetAlertMessage!: (input: any) => void;

  get isPaymentDisabled() {
    if (
      !ValidateEmailFormatError(this.email.value) ||
      this.email.validateError ||
      this.email.value.length > 100 ||
      this.timeWaitingPayment > 0 ||
      !IsKeyBoardEN(this.email.value)
    ) {
      return true;
    }
    return false;
  }

  @Watch("showModal")
  showModalChanged() {
    if (!this.showModal) {
      this.HideModal();
    }
  }

  @Watch("getPaySolutionPaymentLoadingStatus")
  getPaySolutionPaymentLoadingStatusChanged(newVal: LoadingStatusType) {
    if (newVal === LoadingStatusType.Success) {
      if (this.getPaySolutionPaymentModel) {
        this.SubmitToPaySolutions();
      }
    }
  }

  public GetPaySolutionPayment() {
    const input: PaySolutionRequestModel = {
      transactionId: this.transactionId,
      transactionTypeId: this.transactionType,
      transactionNumber: this.transactionNumber,
      customerEmail: this.email.value,
    };
    this.DoGetPaySolutionPayment(input);
  }

  public ValidateEmail() {
    if (!ValidateEmailFormatError(this.email.value) || !IsKeyBoardEN(this.email.value)) {
      this.email.validateError = true;
      this.SetAlertMessage({
        alertMessage: this.$t("Alert_Email_Format_Validation_2"),
        typeMessage: TypeComponentNoti.Error,
      });
    }
  }

  public SubmitToPaySolutions() {
    this.IsLoading(true);
    this.isShowFormSubmit = true;

    setTimeout(() => {
      const formSubmit: any = this.$refs.formSubmit;
      formSubmit.submit();
    }, 0);
  }

  public HideModal() {
    this.$emit("update:showModal", false);
  }
}
